import React from "react";
import { ArrowUpRight } from "lucide-react";
import Shot from "./Shot";
import { t, ui } from "../data/portfolio";

export default function ProjectCard({ project, lang, size = "featured" }) {
  const labels = ui[lang];
  const cover = project.cover ? { src: project.cover } : project.gallery && project.gallery[0];
  const name = t(project.name, lang);

  return (
    <a className={`card card--${size}`} href={`#/proje/${project.slug}`}>
      {size === "featured" && (
        <div className="card-shot">
          <Shot src={cover && cover.src} name={name} lang={lang} ratio="16 / 10" />
        </div>
      )}

      <div className="card-body">
        <div className="card-meta">
          <span className="card-year">{project.year}</span>
          <span className="card-kind">{t(project.kind, lang)}</span>
          {project.live && <span className="card-live" aria-hidden="true" />}
          {project.beta && <span className="card-beta">beta</span>}
        </div>

        <h3 className="card-name">{name}</h3>
        <p className="card-tagline">{t(project.tagline, lang)}</p>

        {size === "featured" && project.metrics && project.metrics.length > 0 && (
          <div className="card-metrics">
            {project.metrics.slice(0, 2).map((m) => (
              <span className="card-metric" key={m.value}>
                <b>{m.value}</b>
                {t(m.label, lang)}
              </span>
            ))}
          </div>
        )}

        <span className="card-open">
          {labels.openProject}
          <ArrowUpRight size={14} strokeWidth={2} />
        </span>
      </div>
    </a>
  );
}
